module.exports = __webpack_public_path__ + "00_glasses.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/00_glasses.png
// module id = oI3p
// module chunks = 0